import React, { Component, PropTypes } from 'react';
import BlackBookImage from '../../../assets/black_book_logo.jpg';
import ImageLink from '../../ImageLink';
import { geti18n } from '../../../utils';

class BBImageLink extends Component {
  static propTypes = {
    blackBookURL: PropTypes.string,
  };
  static defaultProps = {
    blackBookURL: geti18n('linkPaths.blackBookURL'),
  };
  render() {
    const { blackBookURL } = this.props;
    return (
      <ImageLink image={BlackBookImage} url={blackBookURL} linkName="BLACKBOOK" target="_blank" classNames="blackbook-link" />
    )
  }
}

export default BBImageLink;



/** WEBPACK FOOTER **
 ** ./src/components/ImageLink/BBImageLink/index.js
 **/